import { MachineAttribute } from '@internal/utils/machine/MachineAttribute'
import { TSearchFilterNumber } from '@internal/utils/search/TSearchFilterNumber'
import { TRangeFiltersMap } from './TRangeFiltersMap'

export const rangeFiltersMapToSearchFilters = (
  rangeFilters: TRangeFiltersMap
) => {
  const filters: TSearchFilterNumber[] = []
  Object.keys(rangeFilters).forEach((key) => {
    const attribute = key as MachineAttribute

    const data = rangeFilters[attribute]

    if (data.min || data.max) {
      const filter: TSearchFilterNumber = {
        type: 'number',
        attribute,
        min: data.min,
        max: data.max,
      }

      filters.push(filter)
    }
  })

  return filters
}
